var _style, _filter, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobotHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 20",
    style: {
      enableBackground: "new 0 0 17 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{filter:url(#Path_1228);}\n\t.st2{fill:#FFFFFF;}\n")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 50.008,
    id: "Path_1228",
    width: 47.037,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    transform: "translate(-11615.76 -2274.523)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tiles_beamProIcon_1_",
    transform: "translate(11630.76 2287.523)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -13)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228-2_1_",
    className: "st2",
    d: "M6.4,20h4.2 M11.3,20h5.1c0.4,0,0.6-0.3,0.6-0.6c0,0,0,0,0,0V16c0-0.4-0.3-0.6-0.6-0.6 h-2V0.6c0-0.4-0.3-0.6-0.6-0.6c0,0,0,0,0,0H3.4C3.1,0,2.8,0.3,2.8,0.6c0,0,0,0,0,0v14.7H0.6c-0.4,0-0.6,0.3-0.6,0.6c0,0,0,0,0,0 v3.4C0,19.7,0.3,20,0.6,20c0,0,0,0,0,0h5 M8.7,0.6c0.4,0,0.6,0.3,0.6,0.6c0,0,0,0,0,0c0,0.4-0.3,0.6-0.6,0.6c0,0,0,0,0,0h0 c-0.4,0-0.7-0.3-0.7-0.7S8.4,0.6,8.7,0.6L8.7,0.6L8.7,0.6z M13.1,15.3h-9V2.8h9L13.1,15.3L13.1,15.3z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotHead);
export default __webpack_public_path__ + "static/media/robot-head.313633abdd11dc1c9372d1238e834d32.svg";
export { ForwardRef as ReactComponent };